import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import MontserratWoff2 from './Montserrat.woff2';

export const DRAWER_WIDTH = 340;

const montserrat = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `url(${MontserratWoff2}) format('woff2')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const primary = '#2176CD';
const primaryLight = `${primary}40`;
const secondary = '#d50000';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: primary,
      light: primaryLight,
    },
    secondary: {
      main: secondary,
    },
  },
  typography: {
    fontFamily: 'Montserrat, Arial',
    fontSize: 13,
    button: {
      textTransform: 'none',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [montserrat],
        '*::-webkit-scrollbar': {
          backgroundColor: 'rgba(0,0,0,0)',
          width: '0.4em',
          height: '0.4em',
          borderRadius: 10,
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,.2)',
          },
        },
        '*::-webkit-scrollbar-thumb': {
          borderRadius: 10,
          backgroundColor: 'rgba(0,0,0,.3)',
        },
      },
    },
    MuiTableRow: {
      root: {
        '&:hover': {
          backgroundColor: primaryLight,
        },
      },
      hover: {
        backgroundColor: 'unset',
        '&:hover': {
          backgroundColor: `${primaryLight} !important`,
        },
      },
      footer: {
        '&:hover': {
          backgroundColor: 'unset',
        },
      },
      head: {
        '&:hover': {
          backgroundColor: 'unset',
        },
      },
    },
    MuiListItem: {
      root: {
        '&$selected': {
          color: 'white',
          backgroundColor: primary,
          '& .MuiListItemIcon-root': {
            color: 'white',
          },
        },
        '&$selected:hover': {
          color: 'white',
          backgroundColor: primary,
        },
      },
      button: {
        '&:hover': {
          color: primary,
        },
      },
    },
  },
});

const CustomThemeProvider = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default CustomThemeProvider;
